import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { httpGet } from '../Backend';
import { MainConfig } from '../../components/app/entityComponents/Schema';
import { setLocalizationFromMainConfig } from '../../helpers/DateHelper';

interface MainConfigContextType {
    config: MainConfig | null;
    loading: boolean;
    error: Error | null;
}

const MainConfigContext = createContext<MainConfigContextType>({
    config: null,
    loading: true,
    error: null
});

export const useMainConfig = () => useContext(MainConfigContext);

interface MainConfigProviderProps {
    children: ReactNode;
}

export const MainConfigProvider: React.FC<MainConfigProviderProps> = ({ children }) => {
    const [config, setConfig] = useState<MainConfig | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        async function loadConfig() {
            try {
                setLoading(true);
                const result = await httpGet('api/mainConfig/get');
                const data = result.data as MainConfig;
                setConfig(data);
                setLocalizationFromMainConfig(data);
                setError(null);
            } catch (err) {
                setLocalizationFromMainConfig(null);
                setError(err instanceof Error ? err : new Error('Failed to load main config'));
            } finally {
                setLoading(false);
            }
        }

        loadConfig();
    }, []);

    return (
        <MainConfigContext.Provider value={{ config, loading, error }}>
            {children}
        </MainConfigContext.Provider>
    );
};
